/* eslint-disable no-magic-numbers */
import { CircleLayer } from 'mapbox-gl';

import { SymbolLayerWithMapIcon } from '../../components/MapIcon';
import {
  ARTIFICIAL_REEFS_ICON_SIZE,
  ARTIFICIAL_REEFS_MINZOOM,
  ARTIFICIAL_REEFS_SIMPLIFIED_MINZOOM,
  ARTIFICIAL_REEFS_SIMPLIFIED_CIRCLE_RADIUS,
} from '../../constants/mapLayers/artificialReefs';
import { LayerWithToggleableGroup } from '../../types/types';
import { SOURCE } from '../sources';

export const ARTIFICIAL_REEFS_SIMPLIFIED_LAYER: LayerWithToggleableGroup & CircleLayer = {
  id: 'artificial_reefs_simplified_layer',
  type: 'circle',
  source: SOURCE.artificialReefs.name,
  'source-layer': 'artificial_reefs',
  minzoom: ARTIFICIAL_REEFS_SIMPLIFIED_MINZOOM,
  paint: {
    'circle-color': '#836651',
    'circle-radius': ARTIFICIAL_REEFS_SIMPLIFIED_CIRCLE_RADIUS,
    'circle-stroke-color': '#FFFFFF',
    'circle-stroke-width': 1,
  },
  toggleableGroups: null,
};

export const ARTIFICIAL_REEFS_SIMPLIFIED_HIGHLIGHT_LAYER: LayerWithToggleableGroup &
  SymbolLayerWithMapIcon = {
  id: 'artificial_reefs_simplified_highlight_layer',
  type: 'symbol',
  source: SOURCE.artificialReefs.name,
  'source-layer': 'artificial_reefs',
  minzoom: ARTIFICIAL_REEFS_SIMPLIFIED_MINZOOM,
  maxzoom: ARTIFICIAL_REEFS_MINZOOM,
  layout: {
    visibility: 'visible',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'highlight',
    'icon-size': ['step', ['zoom'], 0.7, 8, 0.7, 9, 0.7, 11, 0.8],
  },
  filter: ['==', 'id', ''],
  toggleableGroups: null,
};

export const ARTIFICIAL_REEFS_HIGHLIGHT_LAYER: LayerWithToggleableGroup & SymbolLayerWithMapIcon = {
  id: 'artificial_reefs_highlight_layer',
  type: 'symbol',
  source: SOURCE.artificialReefs.name,
  'source-layer': 'artificial_reefs',
  minzoom: ARTIFICIAL_REEFS_MINZOOM,
  layout: {
    visibility: 'visible',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'highlight',
    'icon-size': ['step', ['zoom'], 0.7, 8, 0.7, 9, 0.7, 11, 0.8],
  },
  filter: ['==', 'id', ''],
  toggleableGroups: null,
};

export const ARTIFICIAL_REEFS_LAYER: LayerWithToggleableGroup & SymbolLayerWithMapIcon = {
  id: 'artificial_reefs_layer',
  type: 'symbol',
  source: SOURCE.artificialReefs.name,
  'source-layer': 'artificial_reefs',
  minzoom: ARTIFICIAL_REEFS_MINZOOM,
  layout: {
    visibility: 'visible',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'artificial_reef',
    'icon-size': ARTIFICIAL_REEFS_ICON_SIZE,
  },
  toggleableGroups: null,
};
